import React from 'react'
import { Switch as MUISwitch } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

interface CustomSwitchProps {
  form: {
    values: any
    setFieldValue: (field: string, value: any) => void
  }
  field: {
    name: string
    value: boolean
  }
}

const StyledSwitch = withStyles({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: 8,
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + $track': {
        backgroundColor: '#44d091',
        opacity: 1,
        border: 'none',
      },
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: '1px solid #c4cdd5',
    backgroundColor: '#dfe3e8',
    opacity: 1,
  },
  checked: {},
})(MUISwitch)

const CustomSwitch: React.FC<CustomSwitchProps> = ({ form, field }) => {
  const { setFieldValue } = form
  const { name, value } = field

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked
    console.log('Switch handleChange:', { name, currentValue: value, newValue })
    setFieldValue(name, newValue)
  }

  const handleClick = () => {
    console.log('Switch handleClick:', { name, currentValue: value })
    setFieldValue(name, !value)
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer'
      }}
      onClick={handleClick}
    >
      <StyledSwitch
        checked={Boolean(value)}
        onChange={handleChange}
        name={name}
      />
      <span style={{
        fontFamily: 'Nunito',
        fontSize: '14px',
        fontWeight: 600,
        color: '#1f2425',
        userSelect: 'none'
      }}>
        Declaro tener la misma dirección tributaria
      </span>
    </div>
  )
}

export default CustomSwitch
